import { cx } from "../lib/cx";

interface SignalPillProps {
  label: string;
  tone?: "positive" | "warning" | "neutral";
}

export function SignalPill({ label, tone = "neutral" }: SignalPillProps) {
  return <span className={cx("signal-pill", `tone-${tone}`)}>{label}</span>;
}
